/**
 * Created by jpilz on 2/13/17.
 */
import ko from 'knockout';
import axios from 'axios';
import inLineStyleObj from './inLineStyleObj';
import editorStyleObj from './editorStyleObj';

export default class optionsUtil {

  constructor(context) {
    this.name = "optionsUtil";
    this.context = context;

    console.log("optionsUtil");
    console.log(this.context);
  }


  restoreMasterStyles() {

    console.log("optionsUtil:restoreMasterStyles:");

    let url = this.context.generateApiUrl('/Editorstyles/EditorStylesRestore');

    let callData = JSON.stringify({
      "subid": this.context.subid(),
      "subparentid": this.context.subparentid(),
      "partnerid": this.context.partnerid()
    });

    return new Promise((resolve, reject) => {
      $.ajax({
        url: url,
        method: 'POST',
        headers: this.context.apiContentType,
        data: callData
      }).done((response, textResponse, request) => {
        console.log("optionsUtil:restoreMasterStyles: response: %o, request: %o", response, request);
        resolve({
          "response": response,
          "request": request
        });
      }).fail((error) => {
        console.log("optionsUtil:restoreMasterStyles: Error: %o", error);
        this.context.eventManager.notifySubscribers({
          modalTitle: "API Error",
          modalBody: "Error processing optionsUtil:restoreMasterStyles"
        }, "messageModel");
        reject(error);
      });
    });
  }

  backupMasterStyles() {

    console.log("optionsUtil:backupMasterStyles:");

    let url = this.context.generateApiUrl('/Editorstyles/EditorStylesBackup');

    let callData = JSON.stringify({
      "subid": this.context.subid(),
      "subparentid": this.context.subparentid(),
      "partnerid": this.context.partnerid()
    });

    return new Promise((resolve, reject) => {
      $.ajax({
        url: url,
        method: 'POST',
        headers: this.context.apiContentType,
        data: callData
      }).done((response, textResponse, request) => {
        console.log("optionsUtil:backupMasterStyles: response: %o, request: %o", response, request);
        resolve({
          "response": response,
          "request": request
        });
      }).fail((error) => {
        console.log("optionsUtil:backupMasterStyles: Error: %o", error);
        this.context.eventManager.notifySubscribers({
          modalTitle: "API Error",
          modalBody: "Error processing optionsUtil:backupMasterStyles"
        }, "messageModel");
        reject(error);
      });
    });
  }

  getMasterStyles() {

    //getInLineStyles
    console.log("optionsUtil:getMasterStyles: subid: %o  subparentid: %o  partnerid: %o", this.context.subid(), this.context.subparentid(), this.context.partnerid());

    //let callData = JSON.stringify({"serviceName":"BLR_Job_Description_Service", "methodName":"getInLineStyles","parameters":[this.context.subid(), type]});
    /* {"where": { "subid": "900423599","styletype": "inline"}, "order": "stylename"} */
    //let filter = encodeURI(JSON.stringify({ "where" : { "subid" : this.context.subid(), "partnerid": this.context.partnerid()} }));
    let url = this.context.generateApiUrl('/Editorstyles/GetEditorStyles');
    let callData = JSON.stringify({
      "subid": this.context.subid(),
      "subparentid": this.context.subparentid(),
      "partnerid": this.context.partnerid()
    });

    return new Promise((resolve, reject) => {
      $.ajax({
        url: url,
        method: 'POST',
        headers: this.context.apiContentType,
        data: callData
      }).done((response, textResponse, request) => {

        console.log("optionsUtil:getMasterStyles: done: %o", response);
        console.log("optionsUtil:getMasterStyles: retArray: %o", response.data);
        resolve(response.data);

      }).fail((error) => {
        console.log("optionsUtil:getMasterStyles: Error: %o", error);
        this.context.eventManager.notifySubscribers({
          modalTitle: "API Error",
          modalBody: "Error getting getInlineStyles"
        }, "messageModel");
        reject(error);
      });
    });
  }

  updateMasterStyles(styleObj) {

    console.log("optionsUtil:updateMasterStyles: styleObj: %o", styleObj);

    let url = this.context.generateApiUrl('/Editorstyles/replaceOrCreate');

    let callData = ko.toJSON(styleObj);

    return new Promise((resolve, reject) => {
      $.ajax({
        url: url,
        method: 'POST',
        headers: this.context.apiContentType,
        data: callData
      }).done((response, textResponse, request) => {
        console.log("optionsUtil:updateMasterStyles: response: %o, request: %o", response, request);
        resolve({
          "response": response,
          "request": request
        });
      }).fail((error) => {
        console.log("optionsUtil:updateMasterStyles: Error: %o", error);
        this.context.eventManager.notifySubscribers({
          modalTitle: "API Error",
          modalBody: "Error processing optionsUtil:updateMasterStyles"
        }, "messageModel");
        reject(error);
      });
    });
  }

  getInlineStyles(type) {

    //getInLineStyles
    console.log("getInlineStyles");
    console.log(this.context.subid());

    //let callData = JSON.stringify({"serviceName":"BLR_Job_Description_Service", "methodName":"getInLineStyles","parameters":[this.context.subid(), type]});
    /* {"where": { "subid": "900423599","styletype": "inline"}, "order": "stylename"} */
    let filter = encodeURI(JSON.stringify({
      "where": {
        "subid": this.context.subparentid(),
        "partnerid": this.context.partnerid(),
        "styletype": type
      },
      "order": "stylename"
    }));
    let url = this.context.generateApiUrl('/Inlinestyles');
    let callData = JSON.stringify({});

    return new Promise((resolve, reject) => {
      axios({
        url: url,
        method: 'get',
        headers: this.context.apiContentType,
        data: callData
      }).then((response) => {
        //console.log("getInlineStyles:");
        //console.log(response.data);
        let retArray = [];

        ko.utils.arrayForEach(response.data, function (item) {
          //console.log(item);
          let tempStyle = new inLineStyleObj(item);
          retArray.push(tempStyle);
        });

        resolve(retArray);

      }).catch((error) => {
        console.log("getInlineStyles Error:");
        this.context.eventManager.notifySubscribers({
          modalTitle: "API Error",
          modalBody: "Error getting getInlineStyles"
        }, "messageModel");
        reject(error);
      });
    });
  }

  updateInlineStyles(styleObj) {
    console.log("updateInlineStyles");
    console.log(styleObj);

    let url = this.context.generateApiUrl('/Inlinestyles/replaceOrCreate');

    let callData = JSON.stringify({
      "id": styleObj.id,
      "styletype": styleObj.styleType,
      "partnerid": this.context.partnerid(),
      "subid": this.context.subid(),
      "stylename": styleObj.styleName(),
      "stylecode": styleObj.styleCode(),
      "createdate": styleObj.createdate
    });

    return new Promise((resolve, reject) => {
      axios({
        url: url,
        method: 'POST',
        headers: this.context.apiContentType,
        data: callData
      }).then((response) => {
        console.log(response.data);
        resolve(response);
      }).catch((error) => {
        console.log("updateOptions Error:");
        this.context.eventManager.notifySubscribers({
          modalTitle: "API Error",
          modalBody: "Error processing updateInlineStyles"
        }, "messageModel");
        reject(error);
      });
    });
  }

  deleteStyles(styleObj) {
    //public function updateInLineStyles($id,$type,$subId,$styleName,$styleCode)

    console.log("deleteStyles");
    console.log(this.context.subid());
    //public function updateEntity($id, $sub, $value, $type)

    let url = this.context.generateApiUrl('/Inlinestyles/' + styleObj.id);

    let callData = JSON.stringify({
      "id": styleObj.id
    });

    //let callData = JSON.stringify({"serviceName":"BLR_Job_Description_Service", "methodName":"deleteInLineStyles","parameters":[styleObj.id,this.context.subid()]});

    return new Promise((resolve, reject) => {
      axios({
        url: url,
        method: 'delete',
        headers: this.context.apiContentType,
        data: callData
      }).then((response) => {
        console.log(response.data);
        resolve(response);
      }).catch((error) => {
        console.log("deleteStyles Error:");
        this.context.eventManager.notifySubscribers({
          modalTitle: "API Error",
          modalBody: "Error processing deleteStyles"
        }, "messageModel");
        reject(error);
      });
    });
  }

  getOptions(type) {

    console.log("getOptions");
    console.log(this.context.subid());

    let url = "";
    let filter = "";
    let callData = "";

    switch (type) {

      case "internal-users":
        this.context.userEmployeeList([]);
        filter = encodeURI(JSON.stringify({
          "where": {
            "subparentid": this.context.subparentid(),
            "partnerid": this.context.partnerid(),
            "valid": 1
          },
          "order": "name"
        }));
        url = this.context.generateApiUrl('/Jdmusers' + '?filter=' + filter);
        break;

      case "departments":
        this.context.userEmployeeList([]);
        filter = encodeURI(JSON.stringify({
          "where": {
            "subid": this.context.subid(),
            "partnerid": this.context.partnerid(),
            "valid": 1
          },
          "order": "name"
        }));
        url = this.context.generateApiUrl('/Jdmusers' + '?filter=' + filter);
        break;

    }

    return new Promise((resolve, reject) => {
      axios({
        url: url,
        method: 'get',
        headers: this.context.apiContentType,
        data: callData
      }).then((response) => {

        switch (type) {


          case "internal-users":

            response.data.unshift({
              "userid": 0,
              "subid": this.context.subid(),
              "subparentid": this.context.subparentid(),
              "partnerid": this.context.partnerid(),
              "email": "",
              "title": "",
              "valid": 1,
              "password": "",
              "jdmuserroleid": 1,
              "name": "Add New User"
            });
            console.log('optionsUtil:getOptions:response internal-users data: %o', response.data);
            break;

        }

        console.log("OptionsUtil:getOptions: %s", type);
        resolve(response.data);
      }).catch((error) => {
        console.log("getOptions Error:");
        this.context.eventManager.notifySubscribers({
          modalTitle: "API Error",
          modalBody: "Error getting data for " + type
        }, "messageModel");
        reject(error);
      });
    });
  }

  updateOptions(type, updateObj) {

    console.log('optionsUtil:updateOptions:  updateObj: %o', updateObj);


    let url = "";
    let filter = "";
    let callData = "";

    switch (type) {

      case "internal-users":
        if (updateObj.userid == 0) {
          updateObj.userid = null;
        }
        console.log('optionsUtil:updateOptions:internal-users:  updateObj: %o', updateObj);
        callData = JSON.stringify(updateObj);
        url = this.context.generateApiUrl('/Jdmusers/replaceOrCreate');
        break;

    }

    return new Promise((resolve, reject) => {
      axios({
        url: url,
        method: 'POST',
        headers: this.context.apiContentType,
        data: callData
      }).then((response) => {
        //console.log(response.data);
        resolve(response.data);
      }).catch((error) => {
        console.log("updateOptions Error:");
        this.context.eventManager.notifySubscribers({
          modalTitle: "API Error",
          modalBody: "optionsUtil:UpdateOptions Error updating options"
        }, "messageModel");
        reject(error);
      });
    });
  }

  completeUserCheck() {

    console.log("completeUserCheck UserID: %s", this.context.loginStatusObj().User);
    console.log(this.context.loginStatusObj());

    let self = this;

    let filter = "";
    let url = this.context.generateApiUrl('/Jdmusers/' + this.context.loginStatusObj().User);
    let callData = "";

    return new Promise((resolve, reject) => {
      $.ajax({
        url: url,
        method: 'GET',
        headers: this.context.apiContentType,
        data: callData
      }).then((data, textResponse, request) => {
        console.log(data);

        /*
        if(data.password.length <= 3)
        {
            console.log("User not up to date");
            self.context.eventManager.notifySubscribers({formMode:"Password Update", broadcastUpdate: true},"updateUser");
        }
        else */
        if (data.valid == 0) {
          self.context.eventManager.notifySubscribers({
            modalTitle: "Error: optionsUtil:completeUserCheck",
            modalBody: "User information invalid"
          }, "messageModel");
          //exit;
        } else {
          //self.context.loginStatusObj().UserValid = true;
          self.context.loginStatusObj.valueHasMutated();
          resolve(data);
        }


      }).fail((error) => {
        console.log("completeUserCheck Error:");
        this.context.eventManager.notifySubscribers({
          modalTitle: "API Error optionsUtil:completeUserCheck",
          modalBody: "Error getting user infromation"
        }, "messageModel");
        reject(error);
      });
    });
  }

  getUser() {

    console.log("getUser");

    let filter = encodeURI(JSON.stringify({
      "where": {
        "userid": this.context.loginStatusObj().User,
        "partnerid": this.context.partnerid(),
        "subparentid": this.context.subparentid(),
        "valid": "1"
      }
    }));
    let url = this.context.generateApiUrl('/Jdmusers' + '?filter=' + filter);
    let callData = "";

    return new Promise((resolve, reject) => {
      axios({
        url: url,
        method: 'GET',
        headers: this.context.apiContentType,
        data: callData
      }).then((response) => {
        console.log(response.data[0]);
        resolve(response.data[0]);
      }).catch((error) => {
        console.log("getUser Error:");
        this.context.eventManager.notifySubscribers({
          modalTitle: "API Error",
          modalBody: "Error in getUser"
        }, "messageModel");
        reject(error);
      });
    });
  }

  updatePassword(userObj, newPassword) {

    console.log("optionsUtil:getUser: user: %o", userObj());

    //let filter = encodeURI(JSON.stringify({"where": {"userid":this.context.loginStatusObj().User, "subid":this.context.subid(), "valid":"1"}}));
    let url = this.context.generateApiUrl('/Jdmusers/updatePassword');
    let callData = JSON.stringify({
      userid: userObj().userid(),
      subparentid: this.context.subparentid(),
      partnerid: userObj().partnerid(),
      password: newPassword()
    });

    return new Promise((resolve, reject) => {
      axios({
        url: url,
        method: 'POST',
        headers: this.context.apiContentType,
        data: callData
      }).then((response) => {
        console.log(response.data[0]);
        resolve(response.data[0]);
        location.reload();
      }).catch((error) => {
        console.log("optionsUtil:getUser: Error: %o", error);
        this.context.eventManager.notifySubscribers({
          modalTitle: "API Error",
          modalBody: "Error in getUser"
        }, "messageModel");
        this.context.Raven.captureMessage('optionsUtil:updatePassword: Password Update Error:');
        reject(error);
      });
    });

  }

  resetPassword(userObj) {

    console.log("optionsUtil:resetPassword: user: %o", userObj());

    //let filter = encodeURI(JSON.stringify({"where": {"userid":this.context.loginStatusObj().User, "subid":this.context.subid(), "valid":"1"}}));
    let url = this.context.generateApiUrl('/Jdmusers/resetPassword');
    let callData = JSON.stringify({
      userid: userObj().userid,
      subid: this.context.subparentid(),
      partnerid: this.context.partnerid()
    });

    return new Promise((resolve, reject) => {
      axios({
        url: url,
        method: 'POST',
        headers: this.context.apiContentType,
        data: callData
      }).then((response) => {
        console.log(response.data[0]);
        resolve(response.data[0]);
      }).catch((error) => {
        console.log("resetPassword Error:");
        this.context.eventManager.notifySubscribers({
          modalTitle: "API Error",
          modalBody: "Error in resetPassword"
        }, "messageModel");
        reject(error);
      });
    });

  }

}



// WEBPACK FOOTER //
// ./src/objects/optionsUtil.js